import { RailBar as RailBarSkeleton } from "@circle-react-uikit/SkeletonLoader/skeletons/Rail";
import { RailMemberList as RailMemberListSkeleton } from "@circle-react-uikit/SkeletonLoader/skeletons/Rail/RailMemberList";
import { RailProfile as RailProfileSkeleton } from "@circle-react-uikit/SkeletonLoader/skeletons/Rail/RailProfile";

import type { RailLoaderVariant } from "./types";

export const RailSkeleton = ({ variant }: { variant: RailLoaderVariant }) => {
  switch (variant) {
    case "rail-profile":
      return <RailProfileSkeleton />;
    case "rail-member-list":
      return <RailMemberListSkeleton />;
    default:
      return <RailBarSkeleton />;
  }
};
